// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2GRWy","inner":"Form_inner__2gFuY","range":"Form_range__3tYEh","name":"Form_name__1rBH3","actions":"Form_actions__32iuG"};